export enum ModalMessages {
  WARNING = "Warning",
  CONNECTING = "Connecting...",
  MISSING_METAMASK = "You don't seem to have Metamask installed. Please, add it to your browser in order to proceed",
  NOT_IMPLEMENTED = "Not implemented",
  NOT_IMPLEMENTED_BODY = "The payment method you selected is currently not implemented. Sorry for the inconvenience",
  CHECK_METAMASK = "Please check your Metamask browser extension",
}
